import React from 'react'

const ErrorMessage = ({ message }: { message?: any }) =>
  message ? <label className="text-red-400 text-xs">{message}</label> : null

export default ErrorMessage
